<template>
  <!-- Main Sidebar -->
  <a-layout-sider collapsible class="sider-primary" breakpoint="lg" collapsed-width="0" width="250px"
    :collapsed="sidebarCollapsed" @collapse="$emit('toggleSidebar', !sidebarCollapsed)" :trigger="null" :class="[
      'ant-layout-sider-' + sidebarColor,
      'ant-layout-sider-' + sidebarTheme,
    ]" theme="light" :style="{ backgroundColor: 'transparent' }">
    <div class="mt-0 text-center mb-10 brand">
      <!--  muicBrand.png -->
      <img style="margin-left: -35px;margin-top: -20px;height: 70px;" src="/images/muiclogoOf.png" alt="" />
      <!-- <span class="font-web" style="margin-top: -10px;font-size: 10px; font-weight: 700; color: #5B0888">MY MUIC</span
        > -->
    </div>
    <!-- this.$store.state.role.RulesUser.roles -->
    <!-- <hr class="mt-1 mb-1" /> -->
    <!-- Sidebar Navigation Menu -->
    <a-menu theme="light" mode="inline">
      <a-menu-item v-if="checkRoleView(['faculty', 'staff', 'student'])">
        <router-link to="/dashboard">
          <span class="icon">
            <a-icon style="margin-right: 1px" type="appstore" theme="outlined" />
          </span>
          <span class="label"> Portal </span>
        </router-link>
      </a-menu-item>
      <a-menu-item v-if="checkRoleView(['faculty', 'staff'])">
        <router-link to="/calendar">
          <span class="icon">
            <a-icon style="margin-right: 1px" type="calendar" theme="outlined" />
          </span>
          <span class="label">Calendar</span>
        </router-link>
      </a-menu-item>
      <a-menu-item v-if="checkRoleView(['faculty', 'staff'])">
        <router-link v-if="['kitsana.chu','kanat','chanchai','anothai.sae','niwat.arm','patipan.wat','ponlapat.mun','rungtipa.sae','rungtipa.sae','threepak.pat'].includes(`${this.$store.state.role.RulesUser.username}`)" to="/chatmessage">
          <span class="icon">
            <a-avatar slot="avatar" shape="square" :size="25" src="/images/Khuncopter.png" />
          </span>
          <span class="label">AI Copter Group Test</span>
        </router-link>
      </a-menu-item>
      <a-menu-item v-if="checkRoleView(['student'])">
        <router-link to="/chatmessage">
          <span class="icon">
            <a-avatar slot="avatar" shape="square" :size="25" src="/images/Khuncopter.png" />
          </span>
          <span class="label"><a-badge :number-style="{ marginTop: '-10px', marginRight: '-30px',color:  '#ffffff', backgroundColor: '#693382', }" count="New Assistant!">AI Copter</a-badge></span>
        </router-link>
      </a-menu-item>
      <!-- document online -->
      <a-menu-item v-if="checkRoleView(['faculty', 'staff'])">
        <router-link to="/document-app">
          <span class="icon">
            <a-avatar slot="avatar" shape="square" :size="25" src="/imageApp/MUIC_APP_512_02.png" />
          </span>
          <span class="label">IC-APP</span>
        </router-link>
      </a-menu-item>
      <!-- 'student' -->
      <a-menu-item v-if="checkRoleView(['faculty', 'staff'])">
        <router-link to="/directory">
          <span class="icon">
            <a-icon style="margin-right: 1px" type="phone" theme="outlined" />
          </span>
          <span class="label">Directory</span>
        </router-link>
      </a-menu-item>
      <!-- admin -->
      <a-menu-item v-if="checkRoleView(['adminRole'])">
        <a target="_blank" href="https://my.muic.io/admin/#/mainadmincard">
          <span class="icon">
            <a-icon style="margin-right: 1px" type="cluster" theme="outlined" />
          </span>
          <span class="label">
            IC Manage
          </span>
        </a>
      </a-menu-item>
      <!-- admin -->
      <a-menu-item class="menu-item-header"> Request Form </a-menu-item>
      <a-menu-item v-if="checkRoleView(['staff'])">
        <router-link to="/hri">
          <span class="icon">
            <a-icon style="margin-right: 1px" type="safety" theme="outlined" />
          </span>
          <span class="label">HRI</span>
        </router-link>
      </a-menu-item>
      <a-menu-item v-if="checkRoleView(['faculty', 'staff', 'student'])">
        <router-link to="/service">
          <span class="icon">
            <a-icon style="margin-right: 1px" type="notification" theme="outlined" />
          </span>
          <span class="label">Service</span>
        </router-link>
      </a-menu-item>
      <a-menu-item v-if="checkRoleView(['faculty', 'staff'])">
        <router-link to="/teaching">
          <span class="icon">
            <a-icon style="margin-right: 1px" type="audit" theme="outlined" />
          </span>
          <span class="label">Teaching record</span>
        </router-link>
      </a-menu-item>
      <a-menu-item v-if="checkRoleView(['faculty', 'staff'])">
        <router-link to="/booking">
          <span class="icon">
            <a-icon style="margin-right: 1px" type="book" theme="outlined" />
          </span>
          <span class="label">Booking Systems</span>
        </router-link>
      </a-menu-item>
      <!-- parking -->
      <a-menu-item v-if="checkRoleView(['student', 'faculty', 'staff'])">
        <a v-if="checkRoleView(['faculty', 'staff'])" target="_blank" href="https://icapp.muic.mahidol.ac.th/parking/ic-staff/#/main">
            <span class="icon">
              <a-icon style="margin-right: 1px" type="car" theme="outlined" />
            </span>
            <span class="label">
              Parking Lot
              <br>
              <span style="font-size: 10px;color: red;" class="ml-45"> For MUIC Faculty and Staff Members </span> 
            </span>
        </a>
        <a v-if="checkRoleView(['student'])" target="_blank" href="https://icapp.muic.mahidol.ac.th/parking/new/#/login">
          <span class="icon">
            <a-icon style="margin-right: 1px" type="car" theme="outlined" />
          </span>
          <span class="label">
            PARKING FEE STUDENT
          </span>
        </a>
      </a-menu-item>
      <a-menu-item v-if="checkRoleView(['student'])">
        <router-link to="/tuitionpayment">
          <span class="icon">
            <a-icon style="margin-right: 1px" type="qrcode" theme="outlined" />
          </span>
          <span class="label">Qr Payment</span>
        </router-link>
      </a-menu-item>
      <!-- ia -->
      <!--  
        <a-sub-menu v-if="checkRoleView(['student'])" key="sub1">
          <span slot="title">
            <span style="margin-left: -10px;" class="icon">
              <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="0.6" d="m16 10 3-3m0 0-3-3m3 3H5v3m3 4-3 3m0 0 3 3m-3-3h14v-3"/>
              </svg>
            </span>
            <span class="label">Course Transfer</span>
          </span>
          <a-menu-item style="margin-left: 10px;" key="1" v-if="checkRoleView(['student'])">
            <router-link to="/coursetransfer">
              <span class="icon">
                <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                  <path fill-rule="evenodd" d="M14 4.182A4.136 4.136 0 0 1 16.9 3c1.087 0 2.13.425 2.899 1.182A4.01 4.01 0 0 1 21 7.037c0 1.068-.43 2.092-1.194 2.849L18.5 11.214l-5.8-5.71 1.287-1.31.012-.012Zm-2.717 2.763L6.186 12.13l2.175 2.141 5.063-5.218-2.141-2.108Zm-6.25 6.886-1.98 5.849a.992.992 0 0 0 .245 1.026 1.03 1.03 0 0 0 1.043.242L10.282 19l-5.25-5.168Zm6.954 4.01 5.096-5.186-2.218-2.183-5.063 5.218 2.185 2.15Z" clip-rule="evenodd"/>
                </svg>
              </span>
              <span class="label">Request</span>
            </router-link>
          </a-menu-item>
          <a-menu-item style="margin-left: 10px;" key="1" v-if="checkRoleView(['student'])">
            <router-link to="/historyrequest">
              <span class="icon">
                <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                  <path fill-rule="evenodd" d="M20 10H4v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8ZM9 13v-1h6v1a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1Z" clip-rule="evenodd"/>
                  <path d="M2 6a2 2 0 0 1 2-2h16a2 2 0 1 1 0 4H4a2 2 0 0 1-2-2Z"/>
                </svg>
              </span>
              <span class="label">Exchange History</span>
            </router-link>
          </a-menu-item>
          <a-menu-item style="margin-left: 10px;" key="2" v-if="checkRoleView(['student'])">
            <router-link to="/coursehistory">
              <span class="icon">
                <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                  <path fill-rule="evenodd" d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm9.408-5.5a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2h-.01ZM10 10a1 1 0 1 0 0 2h1v3h-1a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-1v-4a1 1 0 0 0-1-1h-2Z" clip-rule="evenodd"/>
                </svg>
              </span>
              <span class="label">Course History</span>
            </router-link>
          </a-menu-item>
          <a-menu-item style="margin-left: 10px;" key="3" v-if="checkRoleView(['student'])">
            <router-link to="/gradehistory">
              <span class="icon">
                <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                  <path fill-rule="evenodd" d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm9.408-5.5a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2h-.01ZM10 10a1 1 0 1 0 0 2h1v3h-1a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-1v-4a1 1 0 0 0-1-1h-2Z" clip-rule="evenodd"/>
                </svg>
              </span>
              <span class="label">Grade Comparison</span>
            </router-link>
          </a-menu-item>
        </a-sub-menu>  
      -->

      <!-- ia -->
      <a-menu-item class="menu-item-header"> Personal Pages </a-menu-item>
      <a-menu-item v-if="checkRoleView(['staff'])">
        <router-link to="/profile-overview">
          <span class="icon">
            <a-icon style="margin-right: 1px" type="dashboard" theme="outlined" />
          </span>
          <span class="label">Overview</span>
        </router-link>
      </a-menu-item>
      <!-- std - oaa -->
      <!--  
        <a-menu-item v-if="checkRoleView(['student'])">
          <router-link to="/studentgrade">
            <span class="icon">
              <a-icon
                style="margin-right: 1px"
                type="project"
                theme="outlined"
              />
            </span>
            <span class="label">Study report</span>
          </router-link>
        </a-menu-item>
      -->
      <a-menu-item v-if="checkRoleView(['faculty', 'staff', 'student'])">
        <router-link to="/profile">
          <span class="icon">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10ZM12 7C12 8.10457 11.1046 9 10 9C8.89543 9 8 8.10457 8 7C8 5.89543 8.89543 5 10 5C11.1046 5 12 5.89543 12 7ZM9.99993 11C7.98239 11 6.24394 12.195 5.45374 13.9157C6.55403 15.192 8.18265 16 9.99998 16C11.8173 16 13.4459 15.1921 14.5462 13.9158C13.756 12.195 12.0175 11 9.99993 11Z"
                fill="#111827" />
            </svg>
          </span>
          <span class="label">Profile</span>
        </router-link>
      </a-menu-item>
      <!-- hri menu -->
      <a-menu-item v-if="checkRoleView(['faculty', 'staff'])">
        <router-link to="/leaveofabsence">
          <span class="icon">
            <a-icon style="margin-right: 1px" type="medicine-box" theme="outlined" />
          </span>
          <span class="label">Leave of Absence</span>
        </router-link>
      </a-menu-item>
      <a-menu-item v-if="checkRoleView(['staff'])">
        <router-link to="/smartauthen">
          <span class="icon">
            <a-icon style="margin-right: 1px" type="usergroup-add" theme="outlined" />
          </span>
          <span class="label">Smart Authen log</span>
        </router-link>
      </a-menu-item>
      <a-menu-item v-if="checkRoleView(['staff'])">
        <router-link to="/accesslog">
          <span class="icon">
            <a-icon style="margin-right: 1px" type="environment" theme="outlined" />
          </span>
          <span class="label">Campus access log</span>
        </router-link>
      </a-menu-item>
      <!-- hri menu -->
      <a-menu-item v-if="checkRoleView(['student'])">
        <a target="_blank" href="https://os.muic.io/">
          <span class="icon">
            <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
              <path fill-rule="evenodd" d="M5 5a1 1 0 0 0 1-1 1 1 0 1 1 2 0 1 1 0 0 0 1 1h1a1 1 0 0 0 1-1 1 1 0 1 1 2 0 1 1 0 0 0 1 1h1a1 1 0 0 0 1-1 1 1 0 1 1 2 0 1 1 0 0 0 1 1 2 2 0 0 1 2 2v1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V7a2 2 0 0 1 2-2ZM3 19v-7a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Zm6.01-6a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm2 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm6 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm-10 4a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm6 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm2 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z" clip-rule="evenodd"/>
            </svg>
          </span>
          <span class="label">
            Schedule ( Open Section )
          </span>
        </a>
      </a-menu-item>
      <!-- sa -->
      <a-menu-item v-if="checkRoleView(['student'])">
        <router-link to="/studentactivity">
          <span class="icon">
            <a-icon style="margin-right: 1px" type="diff" theme="outlined" />
          </span>
          <span class="label">Student Activity</span>
        </router-link>
      </a-menu-item>
      <!-- sa -->
      <a-menu-item v-if="checkRoleView(['student'])" class="menu-item-header"> Other Pages </a-menu-item>
      <a-menu-item v-if="checkRoleView(['student'])">
        <a target="_blank" href="https://icapp.muic.mahidol.ac.th/lostandfound/std_login.php">
          <span class="icon">
            <a-icon style="margin-right: 1px" type="search" />
          </span>
          <span class="label">
            Lost and Found
          </span>
        </a>
      </a-menu-item>
      <!--  
        <a-menu-item v-if="checkRoleView(['student'])">
          <router-link to="/coursesyllabus">
            <span class="icon">
              <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                <path d="M17 20v-5h2v6.988H3V15h1.98v5H17Z"/>
                <path d="m6.84 14.522 8.73 1.825.369-1.755-8.73-1.825-.369 1.755Zm1.155-4.323 8.083 3.764.739-1.617-8.083-3.787-.739 1.64Zm3.372-5.481L10.235 6.08l6.859 5.704 1.132-1.362-6.859-5.704ZM15.57 17H6.655v2h8.915v-2ZM12.861 3.111l6.193 6.415 1.414-1.415-6.43-6.177-1.177 1.177Z"/>
              </svg>
            </span>
            <span class="label">Course Syllabus</span>
          </router-link>
        </a-menu-item>
      -->
      <!--  
        <a-menu-item v-if="checkRoleView(['faculty', 'staff', 'student'])">
          <router-link to="/atk">
            <span class="icon">
              <a-icon style="margin-right: 1px" type="heart" theme="outlined" />
            </span>
            <span class="label">MUIC PASS</span>
          </router-link>
        </a-menu-item>
      -->
      <!-- 
        <a-menu-item>
					<router-link to="/tables">
						<span class="icon">
							<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M9 2C8.44772 2 8 2.44772 8 3C8 3.55228 8.44772 4 9 4H11C11.5523 4 12 3.55228 12 3C12 2.44772 11.5523 2 11 2H9Z" fill="#111827"/>
								<path fill-rule="evenodd" clip-rule="evenodd" d="M4 5C4 3.89543 4.89543 3 6 3C6 4.65685 7.34315 6 9 6H11C12.6569 6 14 4.65685 14 3C15.1046 3 16 3.89543 16 5V16C16 17.1046 15.1046 18 14 18H6C4.89543 18 4 17.1046 4 16V5ZM7 9C6.44772 9 6 9.44772 6 10C6 10.5523 6.44772 11 7 11H7.01C7.56228 11 8.01 10.5523 8.01 10C8.01 9.44772 7.56228 9 7.01 9H7ZM10 9C9.44772 9 9 9.44772 9 10C9 10.5523 9.44772 11 10 11H13C13.5523 11 14 10.5523 14 10C14 9.44772 13.5523 9 13 9H10ZM7 13C6.44772 13 6 13.4477 6 14C6 14.5523 6.44772 15 7 15H7.01C7.56228 15 8.01 14.5523 8.01 14C8.01 13.4477 7.56228 13 7.01 13H7ZM10 13C9.44772 13 9 13.4477 9 14C9 14.5523 9.44772 15 10 15H13C13.5523 15 14 14.5523 14 14C14 13.4477 13.5523 13 13 13H10Z" fill="#111827"/>
							</svg>
						</span>
						<span class="label">Tables</span>
					</router-link>
				</a-menu-item>
				<a-menu-item>
					<router-link to="/billing">
						<span class="icon">
							<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M4 4C2.89543 4 2 4.89543 2 6V7H18V6C18 4.89543 17.1046 4 16 4H4Z" fill="#111827"/>
								<path fill-rule="evenodd" clip-rule="evenodd" d="M18 9H2V14C2 15.1046 2.89543 16 4 16H16C17.1046 16 18 15.1046 18 14V9ZM4 13C4 12.4477 4.44772 12 5 12H6C6.55228 12 7 12.4477 7 13C7 13.5523 6.55228 14 6 14H5C4.44772 14 4 13.5523 4 13ZM9 12C8.44772 12 8 12.4477 8 13C8 13.5523 8.44772 14 9 14H10C10.5523 14 11 13.5523 11 13C11 12.4477 10.5523 12 10 12H9Z" fill="#111827"/>
							</svg>
						</span>
						<span class="label">Billing</span>
					</router-link>
				</a-menu-item>
				<a-menu-item>
					<router-link to="/rtl">
						<span class="icon">
							<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path fill-rule="evenodd" clip-rule="evenodd" d="M3 6C3 4.34315 4.34315 3 6 3H16C16.3788 3 16.725 3.214 16.8944 3.55279C17.0638 3.89157 17.0273 4.29698 16.8 4.6L14.25 8L16.8 11.4C17.0273 11.703 17.0638 12.1084 16.8944 12.4472C16.725 12.786 16.3788 13 16 13H6C5.44772 13 5 13.4477 5 14V17C5 17.5523 4.55228 18 4 18C3.44772 18 3 17.5523 3 17V6Z" fill="#111827"/>
							</svg>
						</span>
						<span class="label">RTL</span>
					</router-link>
				</a-menu-item> 
      -->
      <!-- 
        <a-menu-item>
					<router-link to="/sign-in">
						<span class="icon">
							<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path fill-rule="evenodd" clip-rule="evenodd" d="M6 2C5.44772 2 5 2.44772 5 3V4H4C2.89543 4 2 4.89543 2 6V16C2 17.1046 2.89543 18 4 18H16C17.1046 18 18 17.1046 18 16V6C18 4.89543 17.1046 4 16 4H15V3C15 2.44772 14.5523 2 14 2C13.4477 2 13 2.44772 13 3V4H7V3C7 2.44772 6.55228 2 6 2ZM6 7C5.44772 7 5 7.44772 5 8C5 8.55228 5.44772 9 6 9H14C14.5523 9 15 8.55228 15 8C15 7.44772 14.5523 7 14 7H6Z" fill="#111827"/>
							</svg>
						</span>
						<span class="label">Sign In</span>
					</router-link>
				</a-menu-item>
				<a-menu-item>
					<router-link to="/sign-up">
						<span class="icon">
							<svg width="14px" height="14px" viewBox="0 0 14 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
								<title>duplicate</title>
								<g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
									<g id="Tables" transform="translate(-58.000000, -507.000000)" fill="#BFBFBF" fill-rule="nonzero">
										<g id="sidebar" transform="translate(33.000000, 43.000000)">
											<g id="sign-up" transform="translate(16.000000, 455.000000)">
												<g id="duplicate" transform="translate(9.000000, 9.000000)">
													<path d="M4,6 C4,4.89543 4.89543,4 6,4 L12,4 C13.1046,4 14,4.89543 14,6 L14,12 C14,13.1046 13.1046,14 12,14 L6,14 C4.89543,14 4,13.1046 4,12 L4,6 Z" id="Path"></path>
													<path d="M2,0 C0.89543,0 0,0.89543 0,2 L0,8 C0,9.1046 0.89543,10 2,10 L2,4 C2,2.8954305 2.8954305,2 4,2 L10,2 L10,2 C10,0.89543 9.1046,0 8,0 L2,0 Z" id="Path"></path>
												</g>
											</g>
										</g>
									</g>
								</g>
							</svg>
						</span>
						<span class="label">Sign Up</span>
					</router-link>
				</a-menu-item> 
      -->
    </a-menu>
    <!-- / Sidebar Navigation Menu -->
    <!-- Sidebar Footer -->
    <!--  
      <div class="aside-footer">
				<div class="footer-box">
					<span class="icon">
						<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M3 4C3 3.44772 3.44772 3 4 3H16C16.5523 3 17 3.44772 17 4V6C17 6.55228 16.5523 7 16 7H4C3.44772 7 3 6.55228 3 6V4Z" fill="#111827"/>
							<path d="M3 10C3 9.44771 3.44772 9 4 9H10C10.5523 9 11 9.44771 11 10V16C11 16.5523 10.5523 17 10 17H4C3.44772 17 3 16.5523 3 16V10Z" fill="#111827"/>
							<path d="M14 9C13.4477 9 13 9.44771 13 10V16C13 16.5523 13.4477 17 14 17H16C16.5523 17 17 16.5523 17 16V10C17 9.44771 16.5523 9 16 9H14Z" fill="#111827"/>
						</svg>
					</span>
					<h6>Need Help?</h6>
					<p>Please check our docs</p>
					<a-button type="primary" href="https://demos.creative-tim.com/muse-vue-ant-design-dashboard/documentation" block target="_blank">
						DOCUMENTATION
					</a-button>
				</div>
			</div>
    -->
    <!-- / Sidebar Footer -->
    <br><br>
  </a-layout-sider>

  <!-- / Main Sidebar -->
</template>

<script>
export default {
  props: {
    // Sidebar collapsed status.
    sidebarCollapsed: {
      type: Boolean,
      default: false,
    },

    // Main sidebar color.
    sidebarColor: {
      type: String,
      default: "primary",
    },

    // Main sidebar theme : light, white, dark.
    sidebarTheme: {
      type: String,
      default: "light",
    },
  },
  data() {
    return {
      // sidebarCollapsedModel: this.sidebarCollapsed,
    };
  },
  computed: {},
  methods: {
    isEmpty(obj) {
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) return false;
      }
      return true;
    },
    checkRoleView(arrVal) {
      let count = 0;
      let countA = 0;
      for (let index = 0; index < arrVal.length; index++) {
        if (this.$store.state.role.RulesUser.length != 0) {
          if (arrVal[index] === 'adminRole') {
            if (this.$store.state.role.RulesUser.permissions.length !== 0) {
              count++;
            }
          } else {
            if (this.$store.state.role.RulesUser.roles.includes(arrVal[index])) {
              count++;
            }
          }
        }
        // xxxx
        // if(this.$store.state.role.RulesUser.permissions.length !== 0){
        //   countA++;
        // }
      }
      return count > 0 ? true : false;
    },
  },
};
</script>

<style lang="scss" scoped>
.layout-dashboard .ant-layout-sider.sider-primary .brand {
  padding: 0px 8px;
}

.filter-shadow {
  color: transparent;
  background: linear-gradient(183deg, #630fa2, #522c7f);
  background-clip: text;
  filter: drop-shadow(-1px -1px white) drop-shadow(1px 1px darken(white, 50%)) drop-shadow(1px 1px darken(white, 52%)) drop-shadow(1px 1px darken(white, 54%)) drop-shadow(1px 1px darken(white, 56%)) drop-shadow(1px 1px darken(white, 58%)) drop-shadow(1px 1px darken(white, 60%)) drop-shadow(1px 1px darken(white, 62%)) drop-shadow(1px 1px darken(white, 64%)) drop-shadow(1px 1px darken(white, 66%)) drop-shadow(1px 1px darken(white, 68%)) drop-shadow(1px 1px darken(white, 70%)) drop-shadow(12px 12px 30px rgba(black, 0.2)) drop-shadow(12px 12px 10px rgba(black, 0.2));
}

@keyframes bounce {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-20px); }
}

.bouncing-box {
  width: 100px;
  height: 100px;
  background-color: orange;
  border-radius: 10px;
  animation: bounce 1s infinite ease-in-out;
}
</style>
